import React from "react";
import {
  Grid,
  Typography,
  Checkbox,
  IconButton,
  useMediaQuery,
  Tooltip,
} from "@material-ui/core";
import { CloseIcon } from "@icarius-icons";
import { VariableSizeList } from "react-window";
import ProfileImg from "@icarius-common/profileImg";

const HEIGHT = 60;

const Items = React.memo((props) => {

  const {
    items,
    disabledItems,
    selectedKeys,
    getItemSubtitle,
    getItemAvatar,
    handleClick,
    isSelection,
  } = props;

  const isSmall = useMediaQuery(`(max-width:959px)`);

  const Row = ({ index, style }) => {
    const item = items[index];
    const subtitle = getItemSubtitle?.(item);
    const showAvatar = Boolean(getItemAvatar); // pregunto por la funcion porque si devuelve "" se tiene que mostrar igual
    const avatar = getItemAvatar?.(item);
    const disabled = disabledItems ? disabledItems.includes(item.key) : false;

    return (
      <div style={style}>
        <Grid key={item.key} container alignItems="center" style={{ paddingBottom: 10, height: HEIGHT }}>
          <Grid container item xs={10}>
            <div
              style={{ display: "flex", flex: 1, gap: 20, alignItems: "center", cursor: disabled ? "default" : "pointer" }}
              onClick={() => disabled ? null : handleClick(item.key)}
            >
              {
                Boolean(showAvatar) &&
                <ProfileImg
                  image={avatar}
                  size={40}
                />
              }
              <div>
                <Tooltip title={item.value}>
                  <Typography variant="h6" className="whiteText" noWrap style={{ fontWeight: 100, fontSize: 16 }}>
                    {item.value}
                  </Typography>
                </Tooltip>
                {
                  subtitle &&
                  <Tooltip title={subtitle}>
                    <Typography variant="h6" className="whiteText" noWrap style={{ fontWeight: 500, fontSize: 14 }}>
                      {subtitle}
                    </Typography>
                  </Tooltip>
                }
              </div>
            </div>
          </Grid>
          <Grid container alignItems="center" justify="center" item xs={2}>
            {
              !disabled ?
                (
                  isSelection ?
                    <Checkbox onChange={() => handleClick(item.key)} checked={selectedKeys.includes(item.key)} />
                    :
                    <IconButton onClick={() => handleClick(item.key)}>
                      <CloseIcon style={{ fill: "var(--mainText)" }} />
                    </IconButton>
                )
                : null
            }
          </Grid>
        </Grid>
      </div >
    )
  }

  return (
    <VariableSizeList
      style={{ overflowX: "hidden" }}
      className="List"
      height={isSmall ? 150 : 300}
      itemCount={items.length}
      itemSize={() => HEIGHT}
    >
      {Row}
    </VariableSizeList>
  )
})

export default Items;